<template>
  <modal v-model="model" max-width="450">
    <template #title>Operation failed</template>
    <template #content>
      Failed to delete
      <strong>{{ description }}</strong> since it was used during at
      least one full text review.
    </template>
    <template #actions>
      <v-btn @click="dismiss">Dismiss</v-btn>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Common/Modal';
import { ReviewCriteria } from '@/models';

export default {
  name: 'ReviewCriteriaInUseError',
  components: { Modal },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reviewCriteria: {
      type: ReviewCriteria,
      default: null,
    },
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    description() {
      return this.reviewCriteria?.description || '';
    },
  },
  methods: {
    dismiss() {
      this.$emit('input', false);
    },
  },
};
</script>
